/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-03-09 15:39:25
 *
 *******************************************************/

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n } from '@shopify/react-i18n';
import { routes } from 'src/routes';
import queryString from 'query-string';
import history from 'src/routes/history';
import { buildAuthURL } from 'src/helpers';
import {
  checkShopifyPaidPlan,
  isSpecialDiscount2021Expired
} from 'src/helpers/subscription-helper';

import { getSubscriptionStatus as getSubscriptionStatusV3 } from 'src/helpers/subscription-v3-helper';
import { getSubscriptionStatus } from 'src/helpers/subscription-helper';
import { Empty } from 'src/components/views/common/empty';
import { setupFullStoryUser } from 'src/integrations/fullStory';

import * as oauthAction from 'actions/oauth-actions';
import { enableOnboardingV3, checkNewUserSSR } from 'src/helpers/installation-helper';

class Oauth extends Component {
  state = {
    queries: {}
  };

  componentDidMount() {
    const { connectShopify, connectSimulator, connected } = this.props;
    if (!connected) {
      const queries = queryString.parse(this.props.location.search);
      this.setState({ queries });

      // If having auth0Token => access via app simulator
      const { auth0Token } = queries;
      if (auth0Token) {
        connectSimulator(queries);
      } else {
        connectShopify(queries);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    // const queries = queryString.parse(this.props.location.search);
    if (!this.props.connected && nextProps.connected && nextProps.success) {
      // Install app in 2 cases:
      // - Not exist auth token: Store doesn't exist in our DB or store status is uninstalled
      // - Cannot detect session in shopify query params: Store exists in our DB with status active (missed hook uninstalled from shopify)

      // if (
      //   !nextProps.authToken ||
      //   (!queries.session && !queries.auth0Token && nextProps.authToken)
      // ) {
      if (!nextProps.authToken) {
        // Tenant app is not found or uninstalled, redirect to install page
        const redirectURL = buildAuthURL(nextProps.tenantId);
        window.location.href = redirectURL;

        // Skip another process
        return;
      }

      // Handle subscription status
      // If return true, the page is redirect to subscription page, skip another process
      if (this.handleSubscriptionStatus(nextProps)) return;

      // Handle migration plan
      // This process dont allow to go to another pages
      if (this.handleMigrationPlan(nextProps)) return;

      const { status, tenantId, tenantApp, planName } = nextProps;
      const { location } = this.props;
      const selectedPlan = _.get(tenantApp, 'selectedPlan', 'trial');

      // Push data to GA
      let dataLayer = window['dataLayer'] || [];
      dataLayer.push({ status, planName, selectedPlan, event: 'pageview' });

      // Set full story property
      setupFullStoryUser(tenantApp);

      switch (status) {
        case 'active': {
          const { installStatus, tenantApp } = nextProps;
          const isEnableOnboardingV3 = enableOnboardingV3(tenantApp);
          const isNewUser = checkNewUserSSR(tenantApp);

          if (isEnableOnboardingV3) {
            // Check status and go to correct page
            // Don't check status 'theme-setup-error' because we can go any page
            switch (installStatus) {
              case 'accepted-permissions':
              case 'submitted-story-telling-1':
              case 'submitted-story-telling-2':
              case 'submitted-story-telling-3':
              case 'submitted-story-telling-4':
              case 'submitted-story-telling-5':
              case 'submitted-demographic': // For old customer not done old onboarding
              case 'selected-layout':
              case 'synced-data': {
                if (location.pathname !== routes.newInstallation.onboarding()) {
                  history.push(routes.newInstallation.onboarding());
                }
                break;
              }
              case 'submitted-kyc':
                if (isNewUser) {
                  history.push(routes.newInstallation.successInstall());
                  break;
                }
              // eslint-disable-next-line
              case 'submitted-kyc-1':
              case 'submitted-kyc-2':
              case 'submitted-kyc-3': {
                if (location.pathname !== routes.newInstallation.chooseTheme()) {
                  history.push(routes.newInstallation.chooseTheme());
                }
                break;
              }
              case 'submitted-choose-theme': {
                if (location.pathname !== routes.newInstallation.running()) {
                  history.push(routes.newInstallation.running());
                }
                break;
              }
              case 'submitted-onboarding': {
                if (location.pathname !== routes.newInstallation.kyc()) {
                  history.push(routes.newInstallation.kyc());
                }
                break;
              }
              case 'submitted-opensurvey': {
                if (location.pathname !== routes.newInstallation.survey()) {
                  history.push(routes.newInstallation.survey());
                }
                break;
              }
              default:
                history.push(routes.dashboard.view());
                break;
            }
          } else {
            // Check status and go to correct page
            // Don't check status 'theme-setup-error' because we can go any page
            // if (!tenantId.includes('bc-dev-v2')) {
            //   switch (installStatus) {
            //     case 'accepted-permissions': {
            //       if (location.pathname !== routes.demographic.view()) {
            //         history.push(routes.demographic.view());
            //       }
            //       break;
            //     }
            //     case 'submitted-demographic': {
            //       if (location.pathname !== routes.chooseLayout.view()) {
            //         history.push(routes.chooseLayout.view());
            //       }
            //       break;
            //     }
            //     case 'selected-layout': {
            //       if (location.pathname !== routes.initializing.view()) {
            //         history.push(routes.initializing.view());
            //       }
            //       break;
            //     }
            //     case 'synced-data': {
            //       if (location.pathname !== routes.setupComplete.view()) {
            //         history.push(routes.setupComplete.view());
            //       }
            //       break;
            //     }
            //     case 'theme-setup-error': {
            //       if (location.pathname !== routes.themeSetup.view()) {
            //         history.push(routes.themeSetup.view());
            //       }
            //       break;
            //     }
            //     default:
            //       history.push(routes.dashboard.view());
            //       break;
            //   }
            // } else {
            switch (installStatus) {
              // For old customer not done old onboarding
              case 'accepted-permissions':
              case 'submitted-demographic':
              case 'selected-layout':
              case 'synced-data': {
                if (location.pathname !== routes.newInstallation.onboarding()) {
                  history.push(routes.newInstallation.onboarding());
                }
                break;
              }
              default:
                history.push(routes.onboardingOldUser.view());
                break;
            }
            // }
          }
          break;
        }
        case 'disabled': {
          if (location.pathname !== routes.plan.view(tenantId)) {
            history.push(routes.plan.view(tenantId));
          }
          break;
        }
        default:
          break;
      }
    }
  }

  // Handle subscription status
  handleSubscriptionStatus = props => {
    const { tenantApp = {}, history, installStatus, planName, subscriptionV3 } = props;
    const specialDiscountExpiredAt = _.get(tenantApp, 'specialDiscountExpiredAt', 0);

    // Get subscription status
    const { status } = subscriptionV3
      ? getSubscriptionStatusV3(tenantApp)
      : getSubscriptionStatus(tenantApp);

    // Check dev stores
    const isPaymentPlan = checkShopifyPaidPlan(planName);

    // Get charge_id from query params
    // Skip redirect to Plan page if status is expired or exceeded
    const queries = queryString.parse(this.props.location.search);
    const { charge_id } = queries;

    // Go to Subscription page if status is Expired, Exceeded
    const pathName = this.props.location.pathname;

    // Block access app after expired time
    const isSpecialDiscountExpired = isSpecialDiscount2021Expired(
      status,
      specialDiscountExpiredAt,
      7
    );
    if (
      (_.isEmpty(installStatus) || installStatus === 'old-customer-done-onboarding') &&
      !['/plan', '/plan-discount', '/theme-setup', '/package', '/addon'].includes(pathName) &&
      !pathName.includes('/plan-discount-large/') &&
      !pathName.includes('/plan-large/') &&
      !pathName.includes('/package-comparison/') &&
      !charge_id &&
      (status === 'expired' ||
        status === 'exceeded' ||
        status === 'regularExpired' ||
        isSpecialDiscountExpired) &&
      isPaymentPlan
    ) {
      history.push(routes.subscription.plan());

      return true;
    }

    return false;
  };

  // Handle migration to es cluster
  handleMigrationPlan = props => {
    const { tenantApp, history } = props;

    // Get cluster migration
    const { elasticsearchClusterMigrationControl = {} } = tenantApp;

    // Check cluster migration
    if (!_.isEmpty(elasticsearchClusterMigrationControl)) {
      const { lastSyncAt = 0, lastSyncDoneAt = 0 } = elasticsearchClusterMigrationControl;
      const pathName = props.location.pathname;

      if (lastSyncDoneAt < lastSyncAt && !pathName.includes('/plan-migration')) {
        history.push(routes.subscription.migration());

        return true;
      }

      return false;
    }
  };

  render() {
    const { i18n, connected, success } = this.props;
    if (connected && !success) {
      return <Empty message={i18n.translate('AdminHTML.OAuth.Empty.message')} />;
    }
    return <div></div>;
  }
}

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const externalInfo = _.get(tenantApp, 'externalInfo', {});

  return {
    connected: state.oauth.connected,
    success: state.oauth.connectSuccess,
    authToken: state.oauth.authToken,
    tenantId: _.get(tenantApp, 'tenantId', ''),
    tenantApp,
    installStatus: _.get(tenantApp, 'installStatus'),
    planName: _.get(externalInfo, 'plan_name', ''),
    status: _.get(tenantApp, 'status', ''),
    subscriptionV3: _.get(tenantApp, 'settings.subscriptionV3.settings.enable', true)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  connectShopify: (query: Object) => dispatch(oauthAction.connectShopify(query, ownProps.i18n)),
  connectSimulator: (query: Object) => dispatch(oauthAction.connectSimulator(query, ownProps.i18n))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(Oauth));
